module.exports = __webpack_public_path__ + "assets/682221d660622a7ae7ebea450c07604c.png";